import Link from 'next/link'

import FansiWinCard from '@/molecules/FansiWinCard'
import WinSlider from '@/organisms/WinSlider'

export type SlideType = {
  id: number
  title: string
  uri: string
  url: string
}

type FansiWinSliderProps = {
  slides: SlideType[]
}

function FansiWinSlider(props: FansiWinSliderProps) {
  const { slides } = props

  if (slides.length <= 0) return null

  return (
    <WinSlider>
      {slides.map((slide) => (
        <Link href={slide.url} key={slide.id}>
          <a
            target="_blank"
            className="flex-shrink-0 mt-2 w-full max-w-[220px] xl:max-w-[260px] cursor-pointer"
          >
            <FansiWinCard slide={slide} layout="flex" />
          </a>
        </Link>
      ))}
    </WinSlider>
  )
}

export default FansiWinSlider
